export default "__VITE_PUBLIC_ASSET__c20fad54__"